"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ArticleSelectQueryBuilder = exports.WhereType = exports.Article = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SelectQueryBuilder2 = require("../../../utils/query-builder/SelectQueryBuilder");

var _utils = require("../../../utils");

var _char = require("../../../utils/char");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Article = /*#__PURE__*/function () {
  (0, _createClass2["default"])(Article, [{
    key: "content",
    get: function get() {
      return this._content;
    },
    set: function set(content) {
      this._content = content.slice();
    }
  }, {
    key: "data",
    get: function get() {
      return this._content.map(function (content) {
        return content.str;
      });
    }
    /**
     * @deprecated
     */
    ,
    set: function set(data) {
      console.warn("Should not set Mail.data/Mail.lines directly. " + "Use Mail.content instead");
    }
  }]);

  function Article() {
    (0, _classCallCheck2["default"])(this, Article);
    (0, _defineProperty2["default"])(this, "boardname", void 0);
    (0, _defineProperty2["default"])(this, "id", void 0);
    (0, _defineProperty2["default"])(this, "push", void 0);
    (0, _defineProperty2["default"])(this, "date", void 0);
    (0, _defineProperty2["default"])(this, "timestamp", void 0);
    (0, _defineProperty2["default"])(this, "author", void 0);
    (0, _defineProperty2["default"])(this, "status", void 0);
    (0, _defineProperty2["default"])(this, "title", void 0);
    (0, _defineProperty2["default"])(this, "fixed", void 0);
    (0, _defineProperty2["default"])(this, "iterator", void 0);
    (0, _defineProperty2["default"])(this, "sendComment", void 0);
    (0, _defineProperty2["default"])(this, "_content", []);
  }

  (0, _createClass2["default"])(Article, [{
    key: "hasHeader",
    value: function hasHeader() {
      if (this.content.length === 0) {
        return false;
      }

      var authorArea = (0, _char.substrWidth)("dbcs", this.content[0].str, 0, 6).trim();
      return authorArea === "作者";
    }
  }], [{
    key: "fromLine",
    value: function fromLine(line) {
      var article = new Article();
      var str = line.str;
      article.id = +(0, _char.substrWidth)("dbcs", str, 1, 7).trim();
      article.push = (0, _char.substrWidth)("dbcs", str, 9, 2).trim();
      article.date = (0, _char.substrWidth)("dbcs", str, 11, 5).trim();
      article.author = (0, _char.substrWidth)("dbcs", str, 17, 12).trim();
      article.status = (0, _char.substrWidth)("dbcs", str, 30, 2).trim();
      article.title = (0, _char.substrWidth)("dbcs", str, 32).trim();
      article.fixed = (0, _char.substrWidth)("dbcs", str, 1, 7).trim().includes("★");
      return article;
    }
  }, {
    key: "select",
    value: function select(bot) {
      return new ArticleSelectQueryBuilder(bot);
    }
  }]);
  return Article;
}();

exports.Article = Article;
var WhereType;
exports.WhereType = WhereType;

(function (WhereType) {
  WhereType["Boardname"] = "boardname";
  WhereType["Id"] = "id";
  WhereType["Push"] = "push";
  WhereType["Author"] = "author";
  WhereType["Title"] = "title";
})(WhereType || (exports.WhereType = WhereType = {}));

var ArticleSelectQueryBuilder = /*#__PURE__*/function (_SelectQueryBuilder) {
  (0, _inherits2["default"])(ArticleSelectQueryBuilder, _SelectQueryBuilder);

  var _super = _createSuper(ArticleSelectQueryBuilder);

  function ArticleSelectQueryBuilder(bot) {
    var _this;

    (0, _classCallCheck2["default"])(this, ArticleSelectQueryBuilder);
    _this = _super.call(this);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "bot", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "boardname", "");
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "wheres", []);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "id", 0);
    _this.bot = bot;
    return _this;
  }

  (0, _createClass2["default"])(ArticleSelectQueryBuilder, [{
    key: "where",
    value: function where(type, condition) {
      switch (type) {
        case WhereType.Boardname:
          if (this.boardname !== "") {
            console.warn("Cannot call where with type \"".concat(type, "\" multiple times"));
          } else {
            this.boardname = condition;
          }

          break;

        case WhereType.Id:
          this.id = +condition;
          break;

        case WhereType.Push:
          this.wheres.push({
            type: "Z",
            condition: condition
          });
          break;

        case WhereType.Author:
          this.wheres.push({
            type: "a",
            condition: condition
          });
          break;

        case WhereType.Title:
          this.wheres.push({
            type: "/",
            condition: condition
          });
          break;

        default:
          throw new Error("Invalid type: ".concat(type));
      }

      return this;
    }
  }, {
    key: "getQuery",
    value: function getQuery() {
      return this.wheres.map(function (_ref) {
        var type = _ref.type,
            condition = _ref.condition;
        return "".concat(type).concat(condition).concat(_utils.keymap.Enter);
      }).join();
    }
    /**
     * *** This API is STATEFUL. ***
     	Used when search article.
    	Returns an iterator of article list.
     */

  }, {
    key: "getIterator",
    value: function getIterator() {
      var _this2 = this;

      var last_id;
      var iterator = {
        next: function () {
          var _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
            var found, articles, i, line, article;
            return _regenerator["default"].wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!(last_id === 1)) {
                      _context.next = 3;
                      break;
                    }

                    return _context.abrupt("return", {
                      value: null,
                      done: true
                    });

                  case 3:
                    if (last_id) {
                      _context.next = 16;
                      break;
                    }

                    _context.next = 6;
                    return _this2.bot.enterBoardByName(_this2.boardname);

                  case 6:
                    _context.next = 8;
                    return _this2.bot.send(_this2.getQuery());

                  case 8:
                    found = _context.sent;
                    console.log("found", found);

                    if (found) {
                      _context.next = 12;
                      break;
                    }

                    return _context.abrupt("return", {
                      value: null,
                      done: true
                    });

                  case 12:
                    _context.next = 14;
                    return _this2.bot.send("".concat(_utils.keymap.End));

                  case 14:
                    _context.next = 18;
                    break;

                  case 16:
                    _context.next = 18;
                    return _this2.bot.send("".concat(_utils.keymap.PgUp));

                  case 18:
                    articles = [];
                    i = 3;

                  case 20:
                    if (!(i <= 22)) {
                      _context.next = 30;
                      break;
                    }

                    line = _this2.bot.line[i]; // console.log("line", line);

                    if (!(line.str.trim() === "")) {
                      _context.next = 24;
                      break;
                    }

                    return _context.abrupt("break", 30);

                  case 24:
                    article = Article.fromLine(line);
                    article.boardname = _this2.boardname;
                    articles.push(article);

                  case 27:
                    i++;
                    _context.next = 20;
                    break;

                  case 30:
                    // console.log("articles", articles);
                    last_id = articles[0].id;
                    return _context.abrupt("return", {
                      value: articles,
                      done: false
                    });

                  case 34:
                    _context.prev = 34;
                    _context.t0 = _context["catch"](0);
                    return _context.abrupt("return", Promise.reject(_context.t0));

                  case 37:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 34]]);
          }));

          function next() {
            return _next.apply(this, arguments);
          }

          return next;
        }()
      };
      return iterator;
    }
    /**
     * *** This API is STATEFUL. ***
     *  We use this API when clicking an article item of search article list.
    	Returns an article.
     */

  }, {
    key: "getOneInSearch",
    value: function () {
      var _getOneInSearch = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var article;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.bot.send("".concat(this.id).concat(_utils.keymap.Enter).concat(_utils.keymap.Enter));

              case 2:
                article = new Article();
                article.id = this.id;
                article.boardname = this.boardname;
                _context2.next = 7;
                return this.bot.getContent();

              case 7:
                article.content = _context2.sent;

                if (article.hasHeader()) {
                  article.author = (0, _char.substrWidth)("dbcs", this.bot.line[0].str, 7, 50).trim();
                  article.title = (0, _char.substrWidth)("dbcs", this.bot.line[1].str, 7).trim();
                  article.timestamp = (0, _char.substrWidth)("dbcs", this.bot.line[2].str, 7).trim();
                } // go back to search


                _context2.next = 11;
                return this.bot.send("".concat(_utils.keymap.ArrowLeft));

              case 11:
                return _context2.abrupt("return", article);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getOneInSearch() {
        return _getOneInSearch.apply(this, arguments);
      }

      return getOneInSearch;
    }() // Used when click in boarditem, we will only specify boardname.

  }, {
    key: "get",
    value: function () {
      var _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
        var found, id, articles, i, line, article, _i, _i2;

        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.bot.enterBoardByName(this.boardname);

              case 2:
                _context3.next = 4;
                return this.bot.send(this.getQuery());

              case 4:
                found = _context3.sent;

                if (found) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt("return", []);

              case 7:
                if (!(this.id > 0)) {
                  _context3.next = 11;
                  break;
                }

                id = Math.max(this.id - 9, 1);
                _context3.next = 11;
                return this.bot.send("".concat(_utils.keymap.End).concat(_utils.keymap.End).concat(id).concat(_utils.keymap.Enter));

              case 11:
                articles = [];
                i = 3;

              case 13:
                if (!(i <= 22)) {
                  _context3.next = 23;
                  break;
                }

                line = this.bot.line[i];

                if (!(line.str.trim() === "")) {
                  _context3.next = 17;
                  break;
                }

                return _context3.abrupt("break", 23);

              case 17:
                article = Article.fromLine(line);
                article.boardname = this.boardname;
                articles.push(article);

              case 20:
                i++;
                _context3.next = 13;
                break;

              case 23:
                if (!(articles.length >= 2 && articles[0].id === 0)) {
                  _context3.next = 32;
                  break;
                }

                _i = 1;

              case 25:
                if (!(_i < articles.length)) {
                  _context3.next = 32;
                  break;
                }

                if (!(articles[_i].id !== 0)) {
                  _context3.next = 29;
                  break;
                }

                articles[0].id = articles[_i].id - _i;
                return _context3.abrupt("break", 32);

              case 29:
                _i++;
                _context3.next = 25;
                break;

              case 32:
                for (_i2 = 1; _i2 < articles.length; _i2++) {
                  articles[_i2].id = articles[_i2 - 1].id + 1;
                }

                _context3.next = 35;
                return this.bot.enterIndex();

              case 35:
                return _context3.abrupt("return", articles.reverse());

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get() {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "getOne",
    value: function () {
      var _getOne = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
        var found, article;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.bot.enterBoardByName(this.boardname);

              case 2:
                _context4.next = 4;
                return this.bot.send(this.getQuery());

              case 4:
                found = _context4.sent;

                if (found) {
                  _context4.next = 7;
                  break;
                }

                return _context4.abrupt("return", void 0);

              case 7:
                _context4.next = 9;
                return this.bot.send("".concat(this.id).concat(_utils.keymap.Enter).concat(_utils.keymap.Enter));

              case 9:
                article = new Article();
                article.id = this.id;
                article.boardname = this.boardname;
                _context4.next = 14;
                return this.bot.getContent();

              case 14:
                article.content = _context4.sent;

                if (article.hasHeader()) {
                  article.author = (0, _char.substrWidth)("dbcs", this.bot.line[0].str, 7, 50).trim();
                  article.title = (0, _char.substrWidth)("dbcs", this.bot.line[1].str, 7).trim();
                  article.timestamp = (0, _char.substrWidth)("dbcs", this.bot.line[2].str, 7).trim();
                }

                _context4.next = 18;
                return this.bot.enterIndex();

              case 18:
                return _context4.abrupt("return", article);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getOne() {
        return _getOne.apply(this, arguments);
      }

      return getOne;
    }()
  }, {
    key: "getOneIterator",
    value: function () {
      var _getOneIterator = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var found, article;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.bot.enterBoardByName(this.boardname);

              case 2:
                _context5.next = 4;
                return this.bot.send(this.getQuery());

              case 4:
                found = _context5.sent;

                if (found) {
                  _context5.next = 7;
                  break;
                }

                return _context5.abrupt("return", void 0);

              case 7:
                _context5.prev = 7;
                _context5.next = 10;
                return this.bot.send("".concat(this.id).concat(_utils.keymap.Enter).concat(_utils.keymap.Enter));

              case 10:
                article = new Article();
                article.id = this.id;
                article.boardname = this.boardname;
                _context5.next = 15;
                return this.bot.getContentIterator();

              case 15:
                article.iterator = _context5.sent;
                article.sendComment = this.sendComment;
                return _context5.abrupt("return", article);

              case 20:
                _context5.prev = 20;
                _context5.t0 = _context5["catch"](7);
                return _context5.abrupt("return", Promise.reject(_context5.t0));

              case 23:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[7, 20]]);
      }));

      function getOneIterator() {
        return _getOneIterator.apply(this, arguments);
      }

      return getOneIterator;
    }() // assume that we are in an article now.
    // send comment in article
    //  arg = {
    // 		"type" : "1" or "2" or "3"
    //  	"text" : "hello!"
    //    "boardName" : "test",
    //    "aid" : "aid"
    // }

  }, {
    key: "sendComment",
    value: function () {
      var _sendComment = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(arg, bot) {
        var text, lenPerLine, seperateText, _iterator, _step, t;

        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (bot.state.login) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", Promise.reject("not login"));

              case 2:
                text = arg.text;
                text = text.trim();

                if (!(text.length === 0)) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", Promise.reject("empty string"));

              case 6:
                lenPerLine = 52; // 中文字的長度是二

                seperateText = function seperateText(str) {
                  var textParts = [];
                  var strPart = "";

                  for (var i = 0, len = 0; i < str.length;) {
                    if (str[i] >= "\xFF") {
                      // cannot put it in
                      if (len >= lenPerLine - 1) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 2;
                        i++;
                      }
                    } else {
                      if (len == lenPerLine) {
                        textParts.push(strPart);
                        strPart = "";
                        len = 0;
                      } else {
                        strPart += str[i];
                        len += 1;
                        i++;
                      }
                    }
                  }

                  textParts.push(strPart);
                  return textParts;
                };

                text = seperateText(text);
                _context6.prev = 9;
                _iterator = _createForOfIteratorHelper(text);
                _context6.prev = 11;

                _iterator.s();

              case 13:
                if ((_step = _iterator.n()).done) {
                  _context6.next = 35;
                  break;
                }

                t = _step.value;
                _context6.next = 17;
                return bot.send("X");

              case 17:
                console.log("after pressing X", bot.screen);

                if (!bot.line[23].str.includes("您覺得這篇文章")) {
                  _context6.next = 21;
                  break;
                }

                _context6.next = 21;
                return bot.send("".concat(arg.type));

              case 21:
                if (!(bot.line[22].str.includes("使用 → 加註方式") || bot.line[23].str.includes(bot.state.username))) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 24;
                return bot.send("".concat(t).concat(_utils.keymap.Enter));

              case 24:
                _context6.next = 26;
                return bot.send("y".concat(_utils.keymap.Enter));

              case 26:
                console.log("after send ", bot.screen);
                _context6.next = 30;
                break;

              case 29:
                return _context6.abrupt("return", Promise.reject("comment failed"));

              case 30:
                _context6.next = 32;
                return bot.send("".concat(_utils.keymap.Enter));

              case 32:
                console.log("after enter ", bot.screen);

              case 33:
                _context6.next = 13;
                break;

              case 35:
                _context6.next = 40;
                break;

              case 37:
                _context6.prev = 37;
                _context6.t0 = _context6["catch"](11);

                _iterator.e(_context6.t0);

              case 40:
                _context6.prev = 40;

                _iterator.f();

                return _context6.finish(40);

              case 43:
                return _context6.abrupt("return", Promise.resolve("comment success"));

              case 46:
                _context6.prev = 46;
                _context6.t1 = _context6["catch"](9);
                return _context6.abrupt("return", Promise.reject(_context6.t1));

              case 49:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[9, 46], [11, 37, 40, 43]]);
      }));

      function sendComment(_x, _x2) {
        return _sendComment.apply(this, arguments);
      }

      return sendComment;
    }()
  }]);
  return ArticleSelectQueryBuilder;
}(_SelectQueryBuilder2.SelectQueryBuilder);

exports.ArticleSelectQueryBuilder = ArticleSelectQueryBuilder;
var _default = Article;
exports["default"] = _default;